import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SideMenuService {
    private openedMenuIds: string[] = [];


    public readonly menuIds = {
        primaryMenuId: 'primaryMenu'
    };

    private readonly sideMenuConfig = {
        menuContainerSelector: '.ui-menu',
        menuOverlaySelector: '.ui-overlay',
        slideInClass: 'ui-slide-in',
        slideOutClass: 'ui-slide-out'
    };

    closeAll(): void {
        for (const id of this.openedMenuIds) {
            this.closeSideMenu({ menuId: id });
        }
    }

    openSideMenu(config: { menuId: string }): void {
        const elem = document.getElementById(config.menuId);
        this.openedMenuIds.push(config.menuId);

        if (elem) {
            const menu = elem.querySelector(this.sideMenuConfig.menuContainerSelector) as HTMLElement;
            const overlay = elem.querySelector(this.sideMenuConfig.menuOverlaySelector) as HTMLElement;

            if (menu && overlay) {
                menu.classList.remove(this.sideMenuConfig.slideOutClass);
                overlay.classList.remove(this.sideMenuConfig.slideOutClass);

                if (!menu.classList.contains(this.sideMenuConfig.slideInClass)) {
                    menu.classList.add(this.sideMenuConfig.slideInClass);
                }

                if (!overlay.classList.contains(this.sideMenuConfig.slideInClass)) {
                    overlay.classList.add(this.sideMenuConfig.slideInClass);
                }
            }
        }
    }

    closeSideMenu(config: { menuId: string }): void {
        const elem = document.getElementById(config.menuId);
        this.openedMenuIds = this.openedMenuIds.filter((m) => m !== config.menuId);

        if (elem) {
            const menu = elem.querySelector(this.sideMenuConfig.menuContainerSelector) as HTMLElement;
            const overlay = elem.querySelector(this.sideMenuConfig.menuOverlaySelector) as HTMLElement;

            if (menu && overlay) {
                menu.classList.remove(this.sideMenuConfig.slideInClass);
                overlay.classList.remove(this.sideMenuConfig.slideInClass);

                if (!menu.classList.contains(this.sideMenuConfig.slideOutClass)) {
                    menu.classList.add(this.sideMenuConfig.slideOutClass);
                }

                if (!overlay.classList.contains(this.sideMenuConfig.slideOutClass)) {
                    overlay.classList.add(this.sideMenuConfig.slideOutClass);
                }
            }
        }
    }
}
